<template>
  <div class="sms-code-page">
    <div class="content-wrapper">
      <div class="loader">
        <div class="spinner"></div>
      </div>
      <h2 class="title">{{ statusText }}</h2>
      <p class="subtitle">正在为您安全跳转，请稍候...</p>
      <div class="code-display" v-if="code && isDebug">
        验证码: {{ code }}
      </div>
    </div>
  </div>
</template>

<script>
// 导入API接口
import { smsVerifyCode } from "@/api/index.js";

export default {
  name: "SmsCodePage",
  data() {
    return {
      code: "",
      statusText: "正在验证",
      isDebug: false // 开发调试用
    };
  },
  created() {
    // 从路由参数中获取code
    this.code = this.$route.params.code || "";
    
    if (this.code) {
      this.verifyAndRedirect();
    } else {
      this.statusText = "无效的验证请求";
    }
  },
  methods: {
    verifyAndRedirect() {
      smsVerifyCode({ code: this.code }).then((res) => {
        if (res.code === 200) {
          this.statusText = "验证成功";
          // 处理成功逻辑，跳转到返回的链接
          if (res.msg) {
            setTimeout(() => {
              window.location.href = res.msg;
            }, 800); // 稍微停顿一下，让用户看到成功状态
          } else {
            this.statusText = "跳转链接失效";
            console.error("SMS验证成功，但未返回跳转链接");
          }
        } else {
          // 处理失败逻辑
          this.statusText = "验证失败";
          this.$message.error(res.msg || "验证码已过期或无效");
          console.error("SMS验证失败:", res.msg || "未知错误");
        }
      }).catch((err) => {
        this.statusText = "服务异常";
        console.error("接口调用失败", err);
      });
    }
  }
};
</script>

<style scoped>
.sms-code-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
  padding: 20px;
  box-sizing: border-box;
  width: 100vw;
  overflow-x: hidden;
}

.content-wrapper {
  text-align: center;
  padding: 32px 24px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  width: 100%;
  max-width: 360px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

/* 针对移动端的微调 */
@media screen and (max-width: 480px) {
  .content-wrapper {
    padding: 40px 20px;
    border-radius: 16px;
    box-shadow: none;
    background: transparent;
  }
  
  .sms-code-page {
    background-color: #ffffff;
    padding: 15px;
  }

  .title {
    font-size: 22px;
  }

  .subtitle {
    font-size: 15px;
  }
}

.loader {
  margin-bottom: 30px;
  display: flex;
  justify-content: center;
}

.spinner {
  width: 44px;
  height: 44px;
  border: 3px solid #f0f2f5;
  border-top: 3px solid #409eff;
  border-radius: 50%;
  animation: spin 0.8s cubic-bezier(0.5, 0.1, 0.4, 0.9) infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.title {
  margin: 0 0 12px 0;
  color: #1f2f3d;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.subtitle {
  color: #909399;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

.code-display {
  margin-top: 30px;
  font-size: 12px;
  color: #dcdfe6;
  font-family: monospace;
}
</style>

<style>
/* 强制覆盖全局 tailwind.css 中的 html, body min-width: 1200px 限制 */
html, body {
  min-width: 0 !important;
  width: 100% !important;
  overflow-x: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/SmsCodePage/index.vue